/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';

import ExploreContainerItem from './ExploreContainerItem';

import PropTypes from 'util/PropTypes';


@observer
class ExploreContainerItemList extends Component {

	render() {
		return this.getRenderMarkup();
	}

	getRenderMarkup() {
		void( this.props.layoutOwner.renderTracker.shouldRenderCount ); //only render when items list is ready

		const allChildren = this.props.layoutOwner.getChildrenRenderMarkup();

		const items = allChildren.map( (entry) => {
			return {
				render: () => entry.value,
				id: entry.id
			};
		});

		return (
			<div className='explore-content__cards'>
				{items.map( (item) => {
					return <ExploreContainerItem
						key={item.id}
						services={this.props.services}
						containerModel={this.props.model}
						exploreVM={this.props.model.exploreVM}
						item={item}
					/>;
				})}
			</div>
		);
	}
}

ExploreContainerItemList.propTypes = {
	model: PropTypes.object.isRequired,
	services: PropTypes.object.isRequired,
	layoutOwner: PropTypes.object.isRequired
};


export default ExploreContainerItemList;



// WEBPACK FOOTER //
// ./src/js/layout/explorecontainer/ExploreContainerItemList.js